import { StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import styles from '../shared.scss';

import {
  TXTCLI_Automatic_Withdrawal_Limit,
  TXTCLI_Deposit_Limits,
  TXTCLI_Restrict_Login_time,
  TXTWCL_Self_Exclusion
} from './PlayingLimitsReminderContentNL.messages.json';

const PlayingLimitsReminderContentNL: React.FC = () => {
  const depositLimitPath = useSelector(select.account.getDepositLimitPath);

  return (
    <>
      <StarsButton
        variant="text"
        href={depositLimitPath}
        translation={TXTCLI_Deposit_Limits}
        className={styles.link}
      />
      <StarsButton
        variant="text"
        href="/account/responsible/restrict-login-time"
        translation={TXTCLI_Restrict_Login_time}
        className={styles.link}
      />
      <StarsButton
        variant="text"
        href="/account/responsible/automatic-withdrawal-limit"
        translation={TXTCLI_Automatic_Withdrawal_Limit}
        className={styles.link}
      />
      <StarsButton
        variant="text"
        href="/account/responsible/take-a-break-from-us"
        translation={TXTWCL_Self_Exclusion}
        className={styles.link}
      />
    </>
  );
};

export default PlayingLimitsReminderContentNL;
